<template>
  <div class="container">
    <div class="row mt-4 animate__animated animate__fadeIn animate__faster">
      <DropshipPolicyText/>
      <!-- Enter Hub -->
      <div class="col-12 text-center my-5">
        <button
          class="btn btn-primary"
          @click="enter">
          Enter Dropship Hub
        </button>
        <div>
          <small class="text-muted">* By entering the dropship hub you agree to the listed policies above.</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex'
  import DropshipPolicyText from './DropshipPolicyText.vue'

  // Initialize
  const emit = defineEmits(['enterHub'])
  const store = useStore()

  // Methods
  const enter = ()=>{
    store.dispatch('stepForward')
  }
</script>